<script>
    let show = true
    function toggle() {
        show ^= true
    }
</script>

<!-- <h3> Summary 
</h3>  -->
{#if show}
    <p>
        I'm an independent software developer working on full stack web applications.

        <!-- <br>
        Here is some proof that he considers me a dependable person.
        <br>
        <video width="320" height="240" controls loop="true">
            <source src="images/ollie.mp4" type="video/mp4">
            Your browser does not support the video tag.
        </video> -->
    </p>
{/if}

<style>
    p {
        font-size: 1.5em;
    }

</style>